import { FormInput } from "@/components/bnp-ui";

interface NameFieldsProps {
  firstName: string;
  onFirstNameChange: (value: string) => void;
  lastName: string;
  onLastNameChange: (value: string) => void;
}

const NameFields = ({
  firstName,
  onFirstNameChange,
  lastName,
  onLastNameChange,
}: NameFieldsProps) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
    <div className="flex flex-col gap-1.5">
      <label className="text-xs font-bold text-slate-400 uppercase tracking-wider">
        First name <span className="text-rose-500">*</span>
      </label>
      <FormInput
        type="text"
        name="firstName"
        value={firstName}
        placeholder="Enter your first name"
        className="w-full h-12 rounded-xl bg-[#F8FAFC] border-none px-4 text-sm focus:bg-white focus:ring-2 focus:ring-[#153e46]/20 transition-all"
        onChange={(e) => onFirstNameChange(e.target.value)}
        required
      />
    </div>
    <div className="flex flex-col gap-1.5">
      <label className="text-xs font-bold text-slate-400 uppercase tracking-wider">
        Last name <span className="text-rose-500">*</span>
      </label>
      <FormInput
        type="text"
        name="lastName"
        value={lastName}
        placeholder="Enter your last name"
        className="w-full h-12 rounded-xl bg-[#F8FAFC] border-none px-4 text-sm focus:bg-white focus:ring-2 focus:ring-[#153e46]/20 transition-all"
        onChange={(e) => onLastNameChange(e.target.value)}
        required
      />
    </div>
  </div>
);

export default NameFields;
